import { CommonModule, NgOptimizedImage } from '@angular/common';
import { afterNextRender, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NavService } from '../nav/service/nav.service';
import { ContactService } from '../admin/shared/public-api';

@Component({
  selector: 'app-unsubscribe',
  imports: [CommonModule, RouterModule, NgOptimizedImage],
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.scss',
})
export class UnsubscribeComponent {
  private readonly contactService = inject(ContactService);
  private readonly route = inject(ActivatedRoute);
  private readonly navService = inject(NavService);

  loading = true;
  message: string;
  error = false;

  constructor() {
    afterNextRender({
      write: () => {
        this.navService.setGreenBackground();
        const contactId = this.route.snapshot.params['contactId'];
        this.contactService.unsubscribe(contactId).subscribe({
          next: () => {
            this.message = `Tu as été désinscris de la newsletter !`;
          },
          error: () => {
            this.message = `Désolé, une erreur s'est produite. Contacte-nous pour te désinscrire de la newsletter.`;
            this.error = true;
          },
        });
      },
    });
  }
}
